import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/ArticlePage";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/joyagoo-coupon-code", element: <ArticlePage /> },
  { path: "/joyagoo-promo-code", element: <ArticlePage /> },
  { path: "/joyagoo-review", element: <ArticlePage /> },
  { path: "/joyagoo-shipping", element: <ArticlePage /> },
  { path: "/joyagoo-legit", element: <ArticlePage /> },
  { path: "/how-to-use-joyagoo", element: <ArticlePage /> },
  { path: "/joyagoo-spreadsheet", element: <ArticlePage /> },
  { path: "/joyagoo-coupon-april-2026", element: <ArticlePage /> },
  { path: "/joyagoo-discount-new-users", element: <ArticlePage /> },
  { path: "/joyagoo-shipping-to-usa", element: <ArticlePage /> },
  { path: "/joyagoo-spreadsheet-2026", element: <ArticlePage /> },
  { path: "/best-joyagoo-spreadsheet", element: <ArticlePage /> },
  { path: "/joyagoo-haul", element: <ArticlePage /> },
  { path: "/joyagoo-qc-finder", element: <ArticlePage /> },
  { path: "/joyagoo-sheets", element: <ArticlePage /> },
  { path: "/joyagoo-shoes-coupon", element: <ArticlePage /> },
  { path: "/joyagoo-hoodie-deals", element: <ArticlePage /> },
  { path: "/joyagoo-shipping-coupon", element: <ArticlePage /> },
  { path: "/joyagoo-coupon-2026", element: <ArticlePage /> },
  { path: "/joyagoo-free-shipping", element: <ArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
